import {Map} from 'immutable';

import * as action from '../actions';

const initialState = Map({
	form: Map({
		loading: false,
		data: Map({}),
	}),
});

const actionHandlers = {
	// Отправка формы
	[action.sendReview.request]: (state, {form}) => {
		return state
			.setIn(['form', 'loading'], true)
			.setIn(['form', 'data'], Map(form));
	},
	[action.sendReview.success]: state => {
		return state
			.setIn(['form', 'loading'], false)
			.setIn(['form', 'data'], Map({}));
	},
	[action.sendReview.failure]: state => {
		return state
			.setIn(['form', 'loading'], false);
	},
};

export {initialState, actionHandlers};
export default createReducer => createReducer(initialState, actionHandlers);



// WEBPACK FOOTER //
// ./src/reducers/reviewReducer.js